import React from "react";
import { Popover } from "react-bootstrap";

export const popover = (
  <Popover id="popover-basic">
    <Popover.Title as="h3">BUN</Popover.Title>
  </Popover>
);
